import { render, staticRenderFns } from "./design-room.vue?vue&type=template&id=400d8eb0&scoped=true"
import script from "./design-room.vue?vue&type=script&lang=js"
export * from "./design-room.vue?vue&type=script&lang=js"
import style0 from "./design-room.vue?vue&type=style&index=0&id=400d8eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d8eb0",
  null
  
)

export default component.exports